export default "__VITE_ASSET__e9c29e24__"